"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_CLINICAL_PERMISSIONS = exports.ClinicalPermissions = void 0;
/**
 * Permission string catalog for the Clinical bounded context (Stage
 * 6C.5). Format `<module>:<resource>:<action>` — 100% 3-segment from
 * the first entry, honoring Stage 6A's own explicit upfront commitment
 * (`CLINICAL-SECURITY-ARCHITECTURE.md` §1) to match Financial's proven
 * convention rather than Patient's/Appointment's own mixed 2-/3-segment
 * inconsistency (found by the Platform Verification Sprint). Added now,
 * additively — no permission catalog existed for Clinical before this
 * stage, since nothing needed RBAC gating until this stage's REST
 * layer existed to gate. This file adds no new business rule; every
 * permission here gates a workflow whose rule already lives inside a
 * frozen Domain Service (Stage 6C.2) or Application Service (Stage
 * 6C.3).
 *
 * All 8 of this stage's own brief's illustrative examples
 * (`CLINICAL_VIEW`/`CLINICAL_CREATE`/`CLINICAL_UPDATE`/
 * `CLINICAL_COMPLETE`/`CLINICAL_APPROVE`/`CLINICAL_DOCUMENT_FINALIZE`/
 * `CLINICAL_ORDER_CREATE`/`CLINICAL_ORDER_CANCEL`) map cleanly onto
 * real endpoint groups — unlike Financial's own Stage 5C.5 brief
 * (whose CRUD-shaped examples had to be substituted entirely), these
 * are used verbatim. Full endpoint-to-permission mapping:
 * `CLINICAL-REST-ARCHITECTURE.md` §4.
 */
exports.ClinicalPermissions = {
    /** Every read-only endpoint: getPatientClinicalTimeline, getPatientClinicalWorkflowTimeline, getClinicalAuditTrail, getClinicalDocumentVersionHistory, resolveClinicalApprovalChain. */
    CLINICAL_VIEW: 'clinical:record:view',
    /** createEncounter, createClinicalDocument. */
    CLINICAL_CREATE: 'clinical:record:create',
    /** openEncounter, suspendEncounter, resumeEncounter, closeEncounter, cancelEncounter, saveClinicalDocumentDraft, amendClinicalDocument. */
    CLINICAL_UPDATE: 'clinical:record:update',
    /** completeEncounter. */
    CLINICAL_COMPLETE: 'clinical:encounter:complete',
    /** approveClinicalDocument, validateClinicalCoSigner. */
    CLINICAL_APPROVE: 'clinical:document:approve',
    /** finalizeClinicalDocument. */
    CLINICAL_DOCUMENT_FINALIZE: 'clinical:document:finalize',
    /** createClinicalOrder, signClinicalOrder, signClinicalOrderWithApproval. */
    CLINICAL_ORDER_CREATE: 'clinical:order:create',
    /** cancelClinicalOrder. */
    CLINICAL_ORDER_CANCEL: 'clinical:order:cancel',
};
/** Every Clinical permission, flattened — used to seed the `permissions` table. */
exports.ALL_CLINICAL_PERMISSIONS = Object.values(exports.ClinicalPermissions);
//# sourceMappingURL=clinical.permissions.js.map